import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  deleteEmployeeAction,
  editEmployeeAction,
  getEmployeeDetailsAction,
  submitEmployeeAction,
} from "../../../../store/employee/actions";
import { getSessionData } from "../../base/helper/baseHelper";
import Base from "../../base/views/base";
import ConfirmationDialog from "../../base/views/ConfirmationDialog";
import Popup from "../../base/views/Popup";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import EmployeeForm from "./EmployeeForm";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  pricingheader: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

const headCells = [
  { title: "First Name", field: "firstname", defaultSort: "asc" },
  { title: "Last Name", field: "lastname" },
  { title: "Email", field: "email" },
];

function EmployeeLandingPage(props) {
  const [storeId, setStoreId] = useState("");
  const [moduleAccess, setModuleAccess] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteEmployeeObj, setDeleteEmployeeObj] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  const classes = useStyles();
  const {
    employees,
    getEmployees,
    addEmployee,
    editEmployee,
    deleteEmployee,
  } = props;
  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    if (storeId) {
      const userModules = JSON.parse(getSessionData({ key: "userModules" }));
      const employeeModule = userModules.find(
        (module) => module.modulename === "Employee Management"
      );
      setModuleAccess(employeeModule);
      getEmployees(storeId);
    }
  }, [storeId, getEmployees]);

  const addOrEdit = (resetForm) => {
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit({
      ...item,
      emergencycontactno:
        item.emergencycontactno === "0" ? "" : item.emergencycontactno,
    });
    setOpenPopup(true);
  };

  const onDeleteButtonClick = (e, rowData) => {
    setDeleteEmployeeObj({
      store_id: storeId,
      employee_id: rowData.employeeid,
    });
    setOpenDialog(true);
  };

  const handleDelete = () => {
    setOpenDialog(false);
    deleteEmployee(deleteEmployeeObj);
    setDeleteEmployeeObj([]);
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true}>
        {/* <h1 style={{ marginTop: "4%" }}>Employee Management</h1> */}

        <Container
          maxWidth="xl"
          className={classes.container}
          style={{ marginTop: "4%" }}
        >
          <Button
            className={classes.button}
            startIcon={<AddIcon />}
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
            }}
            style={{
              backgroundColor: "rgb(22, 177, 255)",
              color: "white",
              borderRadius: "0.5rem",
            }}
            {...{ disabled: moduleAccess.createaccess === "Y" ? false : true }}
          >
            Add New
          </Button>
        </Container>

        <div className={classes.root}>
          <MaterialTable
            title="Employee List"
            columns={headCells}
            data={employees}
            actions={[
              {
                icon: "edit",
                tooltip: "Edit",
                onClick: (event, rowData) => openInPopup(rowData),
                disabled: moduleAccess.editaccess === "Y" ? false : true,
              },
              {
                icon: "delete",
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  onDeleteButtonClick(event, rowData);
                },
                disabled: moduleAccess.deleteaccess === "Y" ? false : true,
              },
            ]}
            options={{
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
          />
        </div>
        <LandingPageFooter />
        <Popup
          title="Employee Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <EmployeeForm
            recordForEdit={recordForEdit}
            addEmployee={addEmployee}
            editEmployee={editEmployee}
            addOrEdit={addOrEdit}
            storeid={storeId}
          />
        </Popup>
        <ConfirmationDialog
          title="Do you want to proceed?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Stores"
          onSubmit={handleDelete}
        />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({
  employees: state.employee,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addEmployee: (employee) => dispatch(submitEmployeeAction(employee)),
    getEmployees: (storeId) => dispatch(getEmployeeDetailsAction(storeId)),
    editEmployee: (employee) => dispatch(editEmployeeAction(employee)),
    deleteEmployee: (employee) => dispatch(deleteEmployeeAction(employee)),
  };
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(EmployeeLandingPage);
